import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cuándo recibo el ebook?',
    a: 'Apenas finalizás el pago, el ebook llega automáticamente a tu correo en PDF. Podés abrirlo al instante desde el celular, la tablet o la computadora.'
  }, {
    q: '¿Funciona con mi freidora?',
    a: 'Sí. Todas las recetas fueron testeadas y funcionan en cualquier marca o modelo (Philips, Atma, Liliana, Essen, y el resto). Solo puede variar 1 o 2 minutos el tiempo según la potencia de tu equipo.'
  }, {
    q: '¿Necesito saber cocinar para usarlo?',
    a: 'No. Las recetas están escritas para personas que no tienen tiempo ni experiencia. Si podés poner la freidora, podés seguir las instrucciones.'
  }, {
    q: '¿Los ingredientes son fáciles de conseguir?',
    a: 'Todos los ingredientes son de supermercado común. No hay nada raro, importado ni difícil de encontrar.'
  }, {
    q: '¿Realmente es más sano cocinar en air fryer?',
    a: 'Sí. La freidora de aire cocina con muy poca o ninguna grasa. En muchas preparaciones podés reducir hasta un 80% de aceite sin perder sabor ni textura.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tenés 5 días de garantía total. Si no quedás conforme por cualquier motivo, te devolvemos el dinero sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-white" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-brand-purpleDark text-center mb-12" data-id="element-56">
          Preguntas frecuentes
        </h2>

        <div className="space-y-2" data-id="element-57">
          {faqs.map((faq, index) => <div key={index} className="border-b border-brand-purpleLight last:border-0" data-id="element-58">
              <button className="w-full py-6 text-left flex justify-between items-center focus:outline-none group" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-59">
                <span className="font-bold text-brand-darkGray text-lg pr-4 group-hover:text-brand-purple transition-colors" data-id="element-60">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-brand-purple transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-61" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-62">
                <p className="text-brand-mediumGray font-medium leading-relaxed pr-8" data-id="element-63">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}